import * as c from '../constants';

export function isLoading(isLoading) {
    return {
        type: c.MYUSERS_LOADING,
        isLoading
    }
}

export const onGetUsers = (data) => ({
    type: c.MYUSERS_GET,
    data
})

export const getUsers = (params={}) => {
    return (dispatch, getState, { api }) => {
        api.get('/user', params, dispatch)
            .then(response => {
                if(!response) return;
                const { users } = response;
                const newUser = users.map(item => {
                    const fullname = item.first === "" ? "-" : `${item.first} ${item.last}`;
                    return {
                        fullname,
                        ...item
                    }
                })
                sessionStorage.setItem('myusers', JSON.stringify(newUser));
                dispatch(onGetUsers(newUser));
            })
    }
}


export const addUser = (params) => {
    return (dispatch, getState, { api, history, alert }) => {
        api.post('/user', params, dispatch)
            .then(response => {
                if(!response) return false;
                history.push('/profile/users');
                alert.success('User has been successfully added!');
            })       
    }
}


// WEBPACK FOOTER //
// ./src/my-users/actions/index.js